import { FormattedMessage } from 'react-intl'

import LocationSVG from 'app/assets/icons/listing/location-gradient.svg'
import LinearGradientBorderContainer from 'app/components/base/LinearGradientBorderContainer'
import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'

import CollectionTime from '../../../components/CollectionTime'

interface ClickAndCollectBlockProps {
  location?: string | null
  collectionTimeFrames?: TimeFrameModel[]
}

const ClickAndCollectBlock: RFC<ClickAndCollectBlockProps> = ({
  location,
  collectionTimeFrames
}) => {
  const showCollectionTime =
    !!collectionTimeFrames && collectionTimeFrames.length > 0

  return (
    <Stack spacing={1}>
      <LinearGradientBorderContainer
        direction="row"
        borderRadius={1}
        sxContent={{
          justifyContent: 'space-between',
          alignItems: 'center',
          minHeight: 46,
          backgroundColor: 'background.lightGreen',
          padding: 1,
          px: 2
        }}
      >
        <Text variant="body2" sx={{ fontWeight: 500 }}>
          <FormattedMessage defaultMessage="Click & Collect" />
        </Text>
      </LinearGradientBorderContainer>

      {!!location && (
        <Stack
          direction="row"
          spacing={2}
          sx={{ alignItems: 'center', mt: 0.25 }}
        >
          <LocationSVG />

          <Text variant="body2" color="text.third">
            {location}
          </Text>
        </Stack>
      )}

      <Text variant="body2" color="text.third">
        <FormattedMessage defaultMessage="Detailed collection address will be provided after purchase completion." />
      </Text>

      {showCollectionTime && (
        <CollectionTime collectionTimeFrames={collectionTimeFrames} />
      )}
    </Stack>
  )
}

export default ClickAndCollectBlock
